import AdminQueue from './AdminQueue';

export { default as AdminQueueSwitch } from './AdminQueueSwitch';

export default AdminQueue;
